
import { Colors, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import React, { FC } from 'react';
import styled from 'styled-components';

const AlumniWrapper = styled(FlexBox)`
    width: 100%;
    min-height: 42px;
    background-color: #102D69;
    padding: 10px 24.5px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    position: absolute;
    bottom: 0;
    left: 0;
    // cursor: pointer;
    @media(max-width: ${LayoutConst.screen.l}px) {
        padding: 8px;
        min-height: 29px;
    }

`;

const AlumniText = styled(FInter.Text)`
    color: ${Colors.geoWhite100};
    letter-spacing: -0.02em;
    text-align-center;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    user-select: none;
    @media(max-width: ${LayoutConst.screen.l}px) {
        font-size: 11px;
        line-height: 13px
    }
`;

interface IProps {
    isAlumni: boolean | undefined;
}

const DesignerAlumniButton: FC<IProps> = ({ isAlumni }) => {
    if (!isAlumni) return null;

    return (
        <AlumniWrapper offsetTop={16} offsetTopMobile={16} justifyMobile='center'>
            <AlumniText>HSE ART & DESIGN ALUMNI</AlumniText>
        </AlumniWrapper>
    )
}

export default React.memo(DesignerAlumniButton);
import { Colors, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';
import React, { FC } from 'react';
import styled from 'styled-components';

const AlumniWrapper = styled(FlexBox)`
    width: 100%;
    min-height: 42px;
    background-color: #102D69;
    padding: 10px 24.5px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    position: absolute;
    bottom: 0;
    left: 0;
    // cursor: pointer;
    @media(max-width: ${LayoutConst.screen.l}px) {
        padding: 8px;
        min-height: 29px;
    }

`;

const AlumniText = styled(FInter.Text)`
    color: ${Colors.geoWhite100};
    letter-spacing: -0.02em;
    text-align-center;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    user-select: none;
    @media(max-width: ${LayoutConst.screen.l}px) {
        font-size: 11px;
        line-height: 13px
    }
`;

interface IProps {
    isAlumni: boolean | undefined;
}

const DesignerAlumniButton: FC<IProps> = ({ isAlumni }) => {
    if (!isAlumni) return null;

    return (
        <AlumniWrapper offsetTop={16} offsetTopMobile={16} justifyMobile='center'>
            <AlumniText>HSE ART & DESIGN ALUMNI</AlumniText>
        </AlumniWrapper>
    )
}

export default React.memo(DesignerAlumniButton);